// InteliChat route map - ADDITIVE. Mounted as children of the native
// account-scoped AppContainer route (routes/dashboard/dashboard.routes.js)
// so auth, account bootstrap, ActionCable realtime, CommandBar and
// notifications all keep running exactly as native. No native route is
// removed or shadowed; /app/accounts/:id/intelichat/* is a new namespace.
import { frontendURL } from 'dashboard/helper/URLHelper';
import InteliChatShell from '../shell/InteliChatShell.vue';

const TodayWorkspace = () => import('../workspaces/TodayWorkspace.vue');
const InboxWorkspace = () => import('../workspaces/InboxWorkspace.vue');
const CustomersWorkspace = () =>
  import('../workspaces/CustomersWorkspace.vue');
const OrdersWorkspace = () => import('../workspaces/OrdersWorkspace.vue');
const FitmentWorkspace = () => import('../workspaces/FitmentWorkspace.vue');
const RecoveryWorkspace = () => import('../workspaces/RecoveryWorkspace.vue');
const AnalyticsWorkspace = () =>
  import('../workspaces/AnalyticsWorkspace.vue');
const HistoryWorkspace = () => import('../workspaces/HistoryWorkspace.vue');
const TicketsWorkspace = () =>
  import('../workspaces/TicketsWorkspace.vue');

// Same role envelope as the native dashboard home. hideNativeChrome tells
// the AppContainer to skip the native sidebar (the InteliChat shell owns
// the chrome on these routes only).
const meta = (inteliNav, inteliTitle) => ({
  permissions: ['administrator', 'agent', 'custom_role'],
  hideNativeChrome: true,
  inteliNav,
  inteliTitle,
});

export const routes = [
  {
    path: frontendURL('accounts/:accountId/intelichat'),
    component: InteliChatShell,
    children: [
      {
        path: '',
        name: 'intelichat_root',
        redirect: { name: 'intelichat_today' },
        meta: meta('today', 'Today'),
      },
      {
        path: 'today',
        name: 'intelichat_today',
        component: TodayWorkspace,
        meta: meta('today', 'Today'),
      },
      {
        // Optional conversationId = a conversation deep-opened IN-SHELL
        // (Today focus/queue, notifications, redirected native
        // deep-links). InboxWorkspace reads it from the route and
        // drives the native setActiveChat - the agent never drops to
        // the raw native conversation screen.
        path: 'inbox/:conversationId(\\d+)?',
        name: 'intelichat_inbox',
        component: InboxWorkspace,
        meta: meta('inbox', 'Inbox'),
      },
      {
        // All-chats lookup: the native full-search view (SearchView)
        // mounted in-shell. :tab? mirrors the native search route
        // (search/:tab?) exactly, so SearchView's own URL writes
        // (folded back here by intelichatSearchRedirect) keep their
        // params 1:1. Covers EVERY conversation, all statuses.
        path: 'history/:tab?',
        name: 'intelichat_history',
        component: HistoryWorkspace,
        meta: meta('history', 'History'),
      },
      {
        path: 'customers',
        name: 'intelichat_customers',
        component: CustomersWorkspace,
        meta: meta('customers', 'Customers'),
      },
      {
        path: 'orders',
        name: 'intelichat_orders',
        component: OrdersWorkspace,
        meta: meta('orders', 'Orders'),
      },
      {
        path: 'tickets',
        name: 'intelichat_tickets',
        component: TicketsWorkspace,
        meta: meta('tickets', 'Tickets'),
      },
      {
        path: 'fitment',
        name: 'intelichat_fitment',
        component: FitmentWorkspace,
        meta: meta('fitment', 'Fitment'),
      },
      {
        path: 'recovery',
        name: 'intelichat_recovery',
        component: RecoveryWorkspace,
        meta: meta('recovery', 'Recovery'),
      },
      {
        path: 'analytics',
        name: 'intelichat_analytics',
        component: AnalyticsWorkspace,
        meta: meta('analytics', 'Analytics'),
      },
    ],
  },
];

export default { routes };
